<template>
  <ion-page>
    <ion-content :class="'main-background'" :fullscreen="true" slot="fixed"
      :scroll-y="false">
      <ion-button @click="navigate('login')" class="header-button bg-transparent">
        <ion-icon slot="start" :icon="arrowBackOutline"></ion-icon>
      </ion-button>
      <ion-card class="bg-transparent">
        <ion-card-header class="ion-text-center white-bold">Сброс пароля</ion-card-header>
        <ion-card-content>
          <ion-input type="email" inputmode="email" placeholder="Электронная почта" v-model="email"></ion-input>
          <div class="main-button-container">
            <ion-button v-on:click="resetPassword()" class="reset-button">
              OK
            </ion-button>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from '@/model/globalcontext.model';
import router from '@/router/index';
import { CapacitorHttp } from '@capacitor/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonContent,
  IonIcon,
  IonInput,
  IonPage,
  alertController,
} from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';

export default defineComponent({
  props: {
    timeout: { type: Number, default: 1000 },
  },
  name: 'ResetPassword',
  components: {
    IonContent,
    IonPage,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonInput,
    IonButton,
    IonIcon,
  },
  setup() {
    const emailPattern = new RegExp('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})');
    const globalContext = inject('globalContext') as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      arrowBackOutline,
      emailPattern,
      isMobile,
    }
  },
  data() {
    return {
      email: '',
    }
  },

  ionViewWillEnter() {
    this.email = '';
  },

  methods: {
    navigate(routeName: string): void {
      router.push(`/${routeName}`);
    },

    resetPassword(): void {
      if (this.email.trim().length < 1 || !this.emailPattern.test(this.email.trim().toLowerCase())) {
        this.showAlert('Ошибка', 'Укажите корректный адрес электронной почты');
        return;
      }

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/account/force-reset-password/init`,
        data: this.email,
        headers: {
          'Content-Type': 'application/json'
        }
      };

      CapacitorHttp.post(options)
        .then((response) => {
          if (response.status === 400) {
            this.showAlert('Ошибка', 'Попробуйте другой email');
          } else {
            this.showAlert('Сообщение', 'Пароль успешно сброшен. Пожалуйста, проверьте почту.');
            this.navigate('login');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController
        .create({
          header: alertTitle,
          message: alertMessage,
          buttons: ['OK'],
        });

      await alert.present();
    }
  }
});
</script>

<style scoped>
ion-card {
  margin-top: 30vh;
}

ion-card-header {
  letter-spacing: .08em;
  font-size: 2em;
}

ion-input {
  --background: #434343;
  border-radius: 25px;
  opacity: .8;
  font-family: 'Montserrat';
  margin-bottom: 2em;
  color: white;
  --padding-start: 2em;
  --padding-end: 2em;
}

.reset-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.main-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}</style>